import { render, staticRenderFns } from "./OnlCgformErpList.vue?vue&type=template&id=0fada3f8&"
import script from "./OnlCgformErpList.vue?vue&type=script&lang=js&"
export * from "./OnlCgformErpList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformErpList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports